import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import ReactGA from "react-ga4";

const StyledList = styled("ul")(() => ({
    listStyleType: "none",
    paddingLeft: "0px",
    marginTop: "7px",
}));

// Styled list item
const StyledListItem = styled("li")(() => ({
    lineHeight: "140%",
    fontSize: "15px",
}));

// Styled anchor tag
const StyledLink = styled("a")(() => ({
    color: "rgba(0, 0, 0, 0.72)",
}));

const StyledTitle = styled("h3")(() => ({
    margin: "0px",
}));

const StyledTrainingContentContainer = styled("div")(() => ({
    display: "flex",
}));

const StyledTrainingContentItem = styled("div")(() => ({
    flex: "0 0 50%",
    padding: "16px",
}));

// Styled secondary instruction link
const StyledSecondaryInstruction = styled("span")(() => ({
    textDecoration: "none",
    color: "black",
}));

const StyledPaper = styled(Paper)(() => ({
    padding: "16px",
}));

const TrainingVideos = () => {
    ReactGA.send({ hitType: "pageview", page: "/training-content", title: "Training Content" });

    return (
        <StyledTrainingContentContainer>
            <StyledTrainingContentItem>
                <StyledPaper>
                    <StyledTitle>KM Connect Training Materials</StyledTitle>
                    <StyledList>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/1_KM+Connect+Introduction+Video+2.0.mp4"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                KM Connect Introduction
                            </StyledLink>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/2_KM+Connect+Desktop+Link+Video.mp4"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                KM Connect Desktop Link Setup
                            </StyledLink>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/2_KM+Connect+Proxy+Training+Video.mp4"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Proxy Training
                            </StyledLink>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/3_KM+Connect+Listing+Training+Video.mp4"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Listing Training
                            </StyledLink>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/4_KM+Connect+Deal+Training+Video+-+From+Listing.mp4"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Deal Training (From Listing, Landlord/Owner Rep)
                            </StyledLink>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/5_KM+Connect+Deal+Training+Video+-+Without+Listing.mp4"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Deal Training (Without Listing, Tenant/Buyer Rep)
                            </StyledLink>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/5_KM+Connect+Outside+Comp+Training+Video.mp4"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Outside Comp Training
                            </StyledLink>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/7_KM+Connect+Invoice+Training+Video.mp4"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Invoice Training
                            </StyledLink>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/8_KM+Connect+Total+Consideration+Calculator+Training+Video.mp4"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Total Consideration Calculator Training
                            </StyledLink>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/10_KM+Connect+Flyer+Link+Training+Video.mp4"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Flyer Link Training
                            </StyledLink>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/11_KM+Connect+-+Comp+%26+Voucher+Status+Definitions+(Read).pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Comp & Voucher Status Definitions
                            </StyledLink>
                            <StyledSecondaryInstruction>&nbsp;(Read)</StyledSecondaryInstruction>
                        </StyledListItem>
                    </StyledList>
                    <StyledTitle>User Guides</StyledTitle>
                    <StyledList>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/KM+Deal+Comp+Workflow.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                KM Deal Comp Workflow
                            </StyledLink>
                            <StyledSecondaryInstruction>&nbsp;(Read)</StyledSecondaryInstruction>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/KM+Deal+Voucher+Workflow.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                KM Deal Voucher Workflow
                            </StyledLink>
                            <StyledSecondaryInstruction>&nbsp;(Read)</StyledSecondaryInstruction>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/Listing+Workflow.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Listing Workflow
                            </StyledLink>
                            <StyledSecondaryInstruction>&nbsp;(Read)</StyledSecondaryInstruction>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/Outside+Comp+Workflow+(Non+KM).pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Outside Comp Workflow: Non-KM
                            </StyledLink>
                            <StyledSecondaryInstruction>&nbsp;(Read)</StyledSecondaryInstruction>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/Property+Workflow.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Property Workflow
                            </StyledLink>
                            <StyledSecondaryInstruction>&nbsp;(Read)</StyledSecondaryInstruction>
                        </StyledListItem>
                    </StyledList>
                    <StyledTitle>LandVision Training Materials</StyledTitle>
                    <StyledList>
                        <StyledListItem>
                            <StyledLink
                                href="https://support.digmap.com/onlinehelp/landvision/onlinetraining.html"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                LandVision Live Training Schedule
                            </StyledLink>
                            <StyledSecondaryInstruction>&nbsp;(Engage)</StyledSecondaryInstruction>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://support.digmap.com/onlinehelp/landvision/videotutorials.html"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                LandVision Video Tutorials
                            </StyledLink>
                            <StyledSecondaryInstruction>&nbsp;(Watch)</StyledSecondaryInstruction>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://support.digmap.com/onlinehelp/landvision/documentation.html"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                LandVision Document Tutorials
                            </StyledLink>
                            <StyledSecondaryInstruction>&nbsp;(Read)</StyledSecondaryInstruction>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/LandVision+-+High+Res+Printing+training.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                LandVision High-Res Printing Instructions
                            </StyledLink>
                            <StyledSecondaryInstruction>&nbsp;(Read)</StyledSecondaryInstruction>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/kidder_mathews_lightbox_vision__essentials_training (1080p).mp4"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                LandVision Essentials Training
                            </StyledLink>
                            <StyledSecondaryInstruction>&nbsp;(Video)</StyledSecondaryInstruction>
                        </StyledListItem>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/kidder_mathews_lightbox_vision___search_training (1080p).mp4"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                LandVision Search Training
                            </StyledLink>
                            <StyledSecondaryInstruction>&nbsp;(Video)</StyledSecondaryInstruction>
                        </StyledListItem>
                    </StyledList>
                    <StyledTitle>Troubleshooting Documents</StyledTitle>
                    <StyledList>
                        <StyledListItem>
                            <StyledLink
                                href="https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/Troubleshooting+KM+Connect.docx"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Troubleshooting KM Connect "Access Denied" Error
                            </StyledLink>
                            <StyledSecondaryInstruction>&nbsp;(Read)</StyledSecondaryInstruction>
                        </StyledListItem>
                    </StyledList>
                </StyledPaper>
            </StyledTrainingContentItem>
        </StyledTrainingContentContainer>
    );
};

export default TrainingVideos;
